export function toRealPath (path, width, height) {
  let realPath = []
  path.forEach((percentage, index) => {
    if (index % 2) {
      realPath.push(percentage * height)
    } else {
      realPath.push(percentage * width)
    }
  })
  return realPath
}

export function toSVGPath (path) {
  let SVGPath = []
  path.forEach((n, index) => {
    if (!index) {
      SVGPath.push('M')
    }
    if (index && index % 2 === 0) {
      SVGPath.push('L')
    }
    if (index % 2) {
      SVGPath.push(n)
    } else {
      SVGPath.push(n)
    }
  })
  SVGPath.push('z')
  return SVGPath.join(' ')
}

export function toLabelData (data, width, height) {
  let products = []
  // 遍历产品
  let productMap = {}
  // 遍历路径数据
  data.forEach((data) => {
    data.product_number = data.alias || data.name
    // 存在产品
    if (productMap[data.product_number]) {
      productMap[data.product_number].total++
    } else {
      // 不存在产品创建一个未知产品
      productMap[data.product_number] = {
        name: data.product_number,
        number: data.product_number,
        image: 'https://slicejobsmisc.oss-cn-shanghai.aliyuncs.com/prod/imgr/product/zan-wu-tu-pian-0-20180424_160209_976990.png',
        total: 1,
      }
      products.push(productMap[data.product_number])
    }
    data.product = productMap[data.product_number]
    data.realPath = toRealPath(data.path, width, height)
    data.SVGPath = toSVGPath(data.realPath)
  })
  return {
    data,
    products,
    productMap,
    width,
    height,
  }
}

export default {toRealPath, toSVGPath, toLabelData}



// WEBPACK FOOTER //
// ./src/views/question-review/components/LableResult/src/utils.js